import React, { useEffect, useState, useRef } from 'react';

interface PDFPageProps {
  page: any;
  scale?: number;
}

const PDFPage = (props: PDFPageProps) => {
  const { page, scale = 1.3 } = props;
  const [isLoading, setIsLoading] = useState(true);
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');

    const viewport = page.getViewport(scale);
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    const renderContext = {
      canvasContext: context,
      viewport
    };
    page.render(renderContext).promise.then(() => {
      setIsLoading(false);
    });
  }, [page, scale]);

  const conditionalProps = isLoading ? { style: { display: 'none', visibility: 'hidden' } } : {};
  return (
    <div style={{ width: 'fit-content' }}>
      <canvas
        {...conditionalProps}
        ref={canvasRef}
        style={{
          display: 'block'
        }}
      />
    </div>
  );
};

export default PDFPage;


// WEBPACK FOOTER //
// ./src/components/shared/PDFPage.js